import React, { useEffect, useState } from 'react';
import api from '../api'; // ✅ axios இல்லை — api use பண்றோம்

function Dashboard() {
  const [items, setItems]       = useState([]);
  const [lowStock, setLowStock] = useState([]);

  useEffect(() => {
    api.get('/items/').then(res => setItems(res.data || [])).catch(() => {});
    api.get('/items/alerts/low-stock').then(res => setLowStock(res.data || [])).catch(() => {});
  }, []);

  return (
    <div style={s.container}>
      <h1>டாஷ்போர்டு 📊</h1>
      <div style={s.cards}>
        <div style={s.card}>
          <h3>மொத்த பொருட்கள்</h3>
          <h1 style={{ color: '#2ecc71' }}>{items.length}</h1>
        </div>
        <div style={{ ...s.card, backgroundColor: '#fadbd8' }}>
          <h3>குறைந்த Stock</h3>
          <h1 style={{ color: '#e74c3c' }}>{lowStock.length}</h1>
        </div>
      </div>

      {lowStock.length > 0 && (
        <div style={s.alert}>
          <h3>⚠️ Stock குறைவாக உள்ள பொருட்கள்:</h3>
          {lowStock.map(item => (
            <div key={item.id} style={s.alertItem}>
              <span>{item.name_tamil || item.name}</span>
              <span style={{ color: 'red' }}>மீதம்: {item.quantity}</span>
            </div>
          ))}
        </div>
      )}

      <h2 style={{ marginTop: '20px', marginBottom: '12px' }}>எல்லா பொருட்களும்</h2>
      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr style={s.tableHeader}>
              <th style={s.th}>பெயர்</th>
              <th style={s.th}>தமிழ்</th>
              <th style={s.th}>அளவு</th>
              <th style={s.th}>விலை</th>
              <th style={s.th}>நிலை</th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => (
              <tr key={item.id}>
                <td style={s.td}>{item.name}</td>
                <td style={s.td}>{item.name_tamil || '—'}</td>
                <td style={s.td}>{Number(item.quantity) % 1 === 0 ? item.quantity : Number(item.quantity).toFixed(2)}</td>
                <td style={s.td}>₹{item.price}</td>
                <td style={s.td}>
                  <span style={{ color: item.quantity <= (item.low_stock_alert || 10) ? 'red' : 'green', fontWeight: '600' }}>
                    {item.quantity <= (item.low_stock_alert || 10) ? '⚠️ குறைவு' : '✅ சரி'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const s = {
  container: { padding: '20px' },
  cards: { display: 'flex', gap: '20px', marginBottom: '20px' },
  card: { backgroundColor: '#f0f0f0', padding: '20px', borderRadius: '10px', minWidth: '150px', textAlign: 'center' },
  alert: { backgroundColor: '#fff3cd', padding: '15px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #ffc107' },
  alertItem: { display: 'flex', justifyContent: 'space-between', padding: '5px 0' },
  tableWrap: { background: 'white', borderRadius: '10px', overflow: 'auto', border: '1px solid #eee' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHeader: { backgroundColor: '#2c3e50', color: 'white' },
  th: { padding: '12px', textAlign: 'left' },
  td: { padding: '10px', borderBottom: '1px solid #ddd' },
};

export default Dashboard;
